import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

interface ChartCardProps {
  title: string;
  children: React.ReactNode;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <Box
      // Conditionally set styles based on whether we're expanded or not
      sx={{
        border: "1px solid #ccc",
        borderRadius: 2,
        p: 2,
        m: 1,
        flex: "1 1 400px",
        minWidth: "25%",
        position: isExpanded ? "fixed" : "relative",
        top: isExpanded ? 0 : "auto",
        left: isExpanded ? 0 : "auto",
        width: isExpanded ? "100vw" : "25%",
        height: isExpanded ? "100vh" : "25%",
        zIndex: isExpanded ? 9999 : "auto",
        backgroundColor: "#fff", // Ensure a background when expanded
        overflow: "auto", // so content can scroll if needed
      }}
    >
      {/* Header Row: Title + Expand/Collapse Icon */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" align="center" gutterBottom sx={{ flex: 1 }}>
          {title}
        </Typography>

        <IconButton onClick={toggleExpand}>
          {isExpanded ? <CloseIcon /> : <FullscreenIcon />}
        </IconButton>
      </Box>

      {/* Chart content */}
      {children}
    </Box>
  );
};

export default ChartCard;
